import {
  BottomSheet,
  Illustration,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface ApplyForCandidateConfirmationDialogProps {
  modalState: UseModalState;
}

export function ApplyForCandidateConfirmationDialog(
  props: ApplyForCandidateConfirmationDialogProps
) {
  const { modalState } = props;

  const handleClose = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={handleClose} />}
      footer={
        <DialogFooter orientation="horizontal" sx={{ px: 8, pb: 8, pt: 2 }}>
          <Stack spacing={6} width="100%">
            <Button size="large" onClick={handleClose}>
              Got it
            </Button>
          </Stack>
        </DialogFooter>
      }
    >
      <Box sx={{ px: 5, py: 6 }}>
        <Stack
          spacing={8}
          alignItems="center"
          justifyContent="center"
          sx={{ paddingX: 8, paddingTop: 6, paddingBottom: 10 }}
        >
          <Illustration type="shift-booked" />
          <Stack spacing={6}>
            <Text variant="h2" textAlign="center">
              We&apos;ll apply for you 🎉
            </Text>
          </Stack>
        </Stack>
      </Box>
    </BottomSheet>
  );
}
